<ng-container *ngIf="loading">
    <div class="container-with-loading">
        <div class="loading-overlay">
            <mat-spinner></mat-spinner>
        </div>
    </div>
  </ng-container>
  
  
  <mat-card appearance="outlined" [hidden]="loading">
      <mat-card-header>
      </mat-card-header>
      <mat-card-content>
          <form class="form-container" (ngSubmit)="onSubmit(companyForm)" #companyForm="ngForm">
              <mat-card class="example-card" appearance="outlined">
            <mat-card-header>
              <mat-card-title>Datos Generales</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div id="container" class="formControl">
                <div class="control">
                  <mat-form-field class="controlWidth">
                      <mat-label>RFC</mat-label>
                         <input matInput type="text" name="company.rfc" [(ngModel)]="company.rfc">
                      <mat-error>{{ violations['company.rfc']}}</mat-error>
                  </mat-form-field>
                </div>
                <div class="control">
                  <mat-form-field class="controlWidth">
                    <mat-label>Raz&oacute;n Social</mat-label>
                      <input matInput type="text" name="company.name" [(ngModel)]="company.name">
                      <mat-error>{{ violations['company.name']}}</mat-error>
                  </mat-form-field>
                </div>
                <div class="control">
                  <mat-form-field class="controlWidth">
                    <mat-label>Tel&eacute;fono</mat-label>
                    <input matInput type="text" name="company.telephone" [(ngModel)]="company.telephone">
                    <mat-error>{{ violations['company.telephone']}}</mat-error>
                  </mat-form-field>
                </div>
                <div class="control">
                  <mat-form-field class="controlWidth">
                    <mat-label>Celular</mat-label>
                    <input matInput type="text" name="company.cellPhone" [(ngModel)]="company.cellPhone">
                    <mat-error>{{ violations['company.cellPhone']}}</mat-error>
                  </mat-form-field>
                </div>
                <div class="control">
                  <mat-form-field class="controlWidth">
                    <mat-label>Email</mat-label>
                    <input type="email" matInput placeholder="Ex. pat@example.com" name="company.email" [(ngModel)]="company.email">
                    <mat-error>{{ violations['company.email']}}</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
            <mat-card-footer class="example-card-footer">
            </mat-card-footer>
          </mat-card>
          <br>

          <mat-card class="example-card" appearance="outlined">
            <mat-card-header>
              <mat-card-title>Logo</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div id="container" class="formControl">
                <div class="control image-container">
                  
                  <!-- Vista previa del logo -->
                  <img
                    *ngIf="logoPreview"
                    [src]="logoPreview"
                    alt="Logo empresa"
                    class="logo-img"
                  />
              
                  <!-- Input oculto -->
                  <input
                    type="file"
                    accept="image/*"
                    #fileInput
                    hidden
                    (change)="onFileSelected($event)"
                  />
              
                  <!-- Botones -->
                  <div class="buttons">
                    <button type="button" (click)="fileInput.click()">
                      Seleccionar imagen
                    </button>
              
                    <button
                      type="button"
                      [disabled]="!selectedFile"
                      (click)="saveImage()"
                    >
                      Guardar imagen
                    </button>
                  </div>
                </div>
              </div>
              
            </mat-card-content>
            <mat-card-footer class="example-card-footer">
            </mat-card-footer>
          </mat-card>
          <br>
          <mat-card class="example-card" appearance="outlined">
            <mat-card-header>
              <mat-card-title>Direccion</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div id="container" class="formControl">
                <div class="control">
                  <mat-form-field class="controlWidth">
                      <mat-label>Estado</mat-label>
                      <input matInput type="text" name="company.addresses.state" [(ngModel)]="company.addresses!.state">
                      <mat-error>{{ violations['company.addresses.state']}}</mat-error>
                  </mat-form-field>
                </div>
                <div class="control">
                  <mat-form-field class="controlWidth">
                    <mat-label>Municipio</mat-label>
                      <input matInput type="text" name="company.addresses.municipality" [(ngModel)]="company.addresses!.municipality">
                      <mat-error>{{ violations['company.addresses.municipality']}}</mat-error>
                  </mat-form-field>
                </div>
                <div class="control">
                  <mat-form-field class="controlWidth">
                    <mat-label>Colonia</mat-label>
                      <input matInput type="text" name="company.addresses.colony" [(ngModel)]="company.addresses!.colony">
                      <mat-error>{{ violations['company.addresses.colony']}}</mat-error>
                  </mat-form-field>
                </div>
                <div class="control">
                  <mat-form-field class="controlWidth">
                    <mat-label>Calle</mat-label>
                      <input matInput type="text" name="company.addresses.street" [(ngModel)]="company.addresses!.street">
                      <mat-error>{{ violations['company.addresses.street']}}</mat-error>
                  </mat-form-field>
                </div>
                <div class="control">
                  <mat-form-field class="controlWidth">
                    <mat-label>C&oacute;digo Postal</mat-label>
                    <input matInput type="text" name="company.addresses.postal_code" [(ngModel)]="company.addresses!.postal_code">
                    <mat-error>{{ violations['company.addresses.postal_code']}}</mat-error>
                  </mat-form-field>
                </div>
                <div class="control">
                  <mat-form-field class="controlWidth">
                    <mat-label>N&uacute;mero Exterior</mat-label>
                    <input matInput type="text" name="company.addresses.exterior_number" [(ngModel)]="company.addresses!.exterior_number">
                    <mat-error>{{ violations['company.addresses.exterior_number']}}</mat-error>
                  </mat-form-field>
                </div>
                <div class="control">
                  <mat-form-field class="controlWidth">
                    <mat-label>N&uacute;mero Interior</mat-label>
                    <input matInput type="text" name="company.addresses.interior_number" [(ngModel)]="company.addresses!.interior_number">
                    <mat-error>{{ violations['company.addresses.interior_number']}}</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
            <mat-card-footer class="example-card-footer">
            </mat-card-footer>
          </mat-card>
          <br>

          <mat-card class="example-card" appearance="outlined">
            <mat-card-header>
              <mat-card-title>Configuracion</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div id="container" class="formControl">

                <div class="control">
                  <mat-form-field class="controlWidth">
                    <mat-label>Firmas</mat-label>
                    <mat-select [(ngModel)]="company.companyConfigGroups!.signaturesGroupId"  name="company.companyConfigGroups.signaturesGroupId">
                      @for (signatureGroup of signatureGroups ; track signatureGroup.id) {
                        <mat-option [value]="signatureGroup.id">{{ signatureGroup.id }} - {{ signatureGroup.description }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>

                <!--div class="control">
                  <mat-form-field class="controlWidth">
                    <mat-label>Parametros</mat-label>
                    <mat-select [(ngModel)]="signatureConfiguration.parametersGroupId" [compareWith]="compareSignatureTypes" name="signatureGroup.signatureConfigurations{{listIndex}}.signatureType">
                      @for (signatureType of signatureTypes ; track signatureType.id) {
                        <mat-option [value]="signatureType">{{ signatureType.description }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div-->

                <div class="control">
                  <mat-form-field class="controlWidth">
                    <mat-label>Beneficios</mat-label>
                    <mat-select [(ngModel)]="company.companyConfigGroups!.benefitsGroupId" name="company.companyConfigGroups.benefitsGroupId">
                      @for (benefitGroup of benefitGroups ; track benefitGroup.id) {
                        <mat-option [value]="benefitGroup.id">{{ benefitGroup.id }} - {{ benefitGroup.description }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="control">
                  <mat-form-field class="controlWidth">
                    <mat-label>Vacaciones</mat-label>
                    <mat-select [(ngModel)]="company.companyConfigGroups!.holidayGroupId" name="company.companyConfigGroups.holidayGroupId">
                      @for (holidayGroup of holidayGroups ; track holidayGroup.id) {
                        <mat-option [value]="holidayGroup.id">{{ holidayGroup.id }} - {{ holidayGroup.description }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="control">
                  <mat-form-field class="controlWidth">
                    <mat-label>Retenciones</mat-label>
                    <mat-select [(ngModel)]="company.companyConfigGroups!.withholdingsGroupId" name="company.companyConfigGroups.withholdingsGroupId">
                      @for (withholdingGroup of withholdingGroups ; track withholdingGroup.id) {
                        <mat-option [value]="withholdingGroup.id">{{ withholdingGroup.id }} - {{ withholdingGroup.description }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="control">
                  <mat-form-field class="controlWidth">
                    <mat-label>Formulas</mat-label>
                    <mat-select [(ngModel)]="company.companyConfigGroups!.formulasGroupId" name="company.companyConfigGroups.formulasGroupId">
                      @for (formulaGroup of formulaGroups ; track formulaGroup.id) {
                        <mat-option [value]="formulaGroup.id">{{ formulaGroup.id }} - {{ formulaGroup.description }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="control">
                  <mat-form-field class="controlWidth">
                    <mat-label>Costos por Empleado</mat-label>
                    <mat-select [(ngModel)]="company.companyConfigGroups!.costsPerEmployeesGroupId" name="company.companyConfigGroups.costsPerEmployeesGroupId">
                      @for (costsPerEmployeeGroup of costsPerEmployeeGroups ; track costsPerEmployeeGroup.id) {
                        <mat-option [value]="costsPerEmployeeGroup.id">{{ costsPerEmployeeGroup.id }} - {{ costsPerEmployeeGroup.description }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>

              </div>
            </mat-card-content>
          </mat-card>
          <br>

          <button mat-flat-button class="button" click="onSubmit()">Guardar</button>
          </form>
      </mat-card-content>
    <mat-card-footer class="example-card-footer">
    </mat-card-footer>
    <br>
  </mat-card>